export const GET_FAMILY_HISTORY_DATA = "get_family_history_data";
export const REQ_FAMILY_HISTORY_DATA = "req_family_history_data";
export const SET_FAMILY_HISTORY_DATA = "set_family_history_data";
export const GET_DISEASE_LIST = "get_disease_list";
